import React from 'react';
import alertStarZoomPng from '../../../../../../alert-star-zoom.png';

function DashboardEmptyAlertMessage() {
  return (
    <div className="row">
      <div className="col-lg-10 col-lg-offset-1">
        <div className="alert alert-info text-center">
          <p>
            Add
            <b>alerts</b>
            {' '}
            to your dashboard by
            <br />
            starring them from your alert list.
          </p>
          <p><img src={alertStarZoomPng} alt="alert-star-zoom-img" /></p>
        </div>
      </div>
    </div>
  );
}

export default DashboardEmptyAlertMessage;
